import { render, staticRenderFns } from "./pk-detail-dialog.vue?vue&type=template&id=48ab08cc&scoped=true"
import script from "./pk-detail-dialog.vue?vue&type=script&lang=js"
export * from "./pk-detail-dialog.vue?vue&type=script&lang=js"
import style0 from "./pk-detail-dialog.vue?vue&type=style&index=0&id=48ab08cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ab08cc",
  null
  
)

export default component.exports